<template>
  <div>
    <!-- Inline -->
    <div class="row q-mb-md">
      <!-- Filters hide/show button -->
      <div class="col-6">
        <div class="row" style="justify-content: flex-start">
          <div>
            <q-btn
              @click="showFilters();"
              :text-color="hideFilters ? 'grey-5' : 'white'"
              class="neutral-btn ctrl-button btn-compact"
              :class="{ primary: !hideFilters }"
              icon="filter_list"
              :icon-right="hideFilters ? 'keyboard_arrow_up' : 'keyboard_arrow_down'"
            />
          </div>
          <!-- General searchfield -->
          <div class="q-ml-md" style="flex-grow: 1">
            <q-input
              :disable="!hideFilters || activeFilters"
              color="grey-5"
              v-model="searchTerm"
              @input="applyFilters"
              :placeholder="getString('module.blog.list.filter.label')"
            />
          </div>
        </div>
      </div>
      <!-- Add button -->
      <div class="col-6" style="justify-content: flex-end">
        <q-btn v-if="$store.state.meStore.me.rights.includes(`${permission}.add`)"
          class="capitalize ctrl-button right"
          color="ctrl-turquoise"
          :label="getString('action.add')"
          @click="$router.push(`/${module}/add`)"
          icon-right="add"
        />
        <q-btn v-if="$store.state.meStore.me.rights.includes(`${permission}.delete`)"
          class="capitalize ctrl-button bg-ctrl-grey right q-mr-md"
          color="ctrl-turquoise"
          :disabled="!rowSelection.length"
          :label="$store.state.stringsStore.strings.list.actions.label"
          :class="{ 'button-active': rowSelection.length }">
            <q-icon size="large" name="mdi-chevron-down"/>
            <i v-show="rowSelection.length" class="counter">{{rowSelection.length}}</i>
            <!-- Direct child of target -->
            <q-popover anchor="bottom middle" self="top middle">
              <q-list link>
                <q-item
                  :class="{ 'disabled': !rowSelection.length }"
                  class="toolbar-list-item" @click.native="removeRows('errorcode')">
                  <q-icon color="positive" size="large" name="delete"/>
                  {{$store.state.stringsStore.strings.action.remove}}
                </q-item>
              </q-list>
            </q-popover>
        </q-btn>
      </div>
    </div>
    <!-- Filters block -->
    <transition name="fade">
    <div v-if="!hideFilters" class="table-block q-mb-md">
      <div class="row q-pt-md q-pl-md q-pr-md" style="justify-content: space-between;">
        <!-- Select field -->
        <div class="col-6 q-pb-md q-pl-md q-pr-md">
          <q-select
            multiple
            v-model="filters.source"
            @input="applyFilters"
            :options="sourceOptions"
            :float-label="getString('errorcode.source.header')"
            />
        </div>
        <!-- Input field -->
        <div class="col-6 q-pb-md q-pl-md q-pr-md">
          <q-input
            v-model="filters.code"
            @input="applyFilters"
            float-label="Code"
          />
        </div>
      </div>
      <div class="row q-pb-md q-pl-md q-pr-md">
        <!-- Inputfield -->
        <div class="col-6 q-pl-md q-pr-md">
          <q-input color="primary"
          v-model="filters.description"
          @input="applyFilters"
          :float-label="getString('description')"/>
        </div>
      </div>
      <div class="row q-pl-md q-pr-md" style="justify-content: space-between;">
        <div></div>
        <div class="q-pl-md q-pr-md q-pb-md" style="vertical-align: middle;">
          <q-btn
            :disable="!activeFilters"
            @click="resetFilters();"
            class="capitalize ctrl-button"
            :color="activeFilters ? 'primary' : 'grey-4'"
            label="Reset"
          />
        </div>
      </div>
    </div>
    </transition>
    <!-- Data table -->
    <table-overview
      :endpoint="endpoint"
      :responseFormat="responseData.multiple"
      :columns="columns"
      :permission="permission"
      :module="module"
      :selectable="selectable">
    </table-overview>
  </div>
</template>

<script>
import EventBus from '@/event-bus';
import TableOverview from '@/components/overview/TableOverview.vue';
// Mixins
import filtersMixin from '@/mixins/tables/filtersMixin';
import getString from '@/helpers/GetStrings';
import common from '../common';

export default {
  mixins: [
    common,
    filtersMixin,
  ],
  components: {
    TableOverview,
  },
  data() {
    return {
      rowSelection: [],
      filters: {
        code: '',
        source: [],
      },

      sourceOptions: [
        {
          label: this.getString('errorcode.source.service'),
          value: 'service',
        },
        {
          label: this.getString('errorcode.source.internal'),
          value: 'internal',
        },
        {
          label: this.getString('errorcode.source.external'),
          value: 'external',
        },
        {
          label: this.getString('errorcode.source.combination'),
          value: 'combination',
        },
      ],
      searchTerm: '',
      selectable: true,
      isLoading: false,
      columns: [
        {
          name: '__slot:error-code',
          title: 'Code',
          sortField: 'code',
          titleClass: 'text-left sortable vcol-l',
          dataClass: 'text-left vcol-l text-ellipsis',
        },
        {
          name: '__slot:error-source',
          title: getString('errorcode.source.header'),
          sortField: 'source',
          titleClass: 'text-left sortable vcol-l',
          dataClass: 'text-left vcol-l text-ellipsis',
        },
        {
          name: '__slot:unit-standard',
          title: getString('errorcode.unit.standard'),
          sortField: 'standard',
          titleClass: 'text-left sortable vcol-s',
          dataClass: 'text-left vcol-l text-ellipsis',
        },
        {
          name: '__slot:unit-inverter',
          title: getString('errorcode.unit.inverter'),
          sortField: 'inverter',
          titleClass: 'text-left sortable vcol-s',
          dataClass: 'text-left vcol-l text-ellipsis',
        },
      ],
      hideFilters: true,
      preferences: {
        page: 1,
        perPage: 10,
        sortField: null,
        sortOrder: null,
      },
    };
  },
  methods: {
    getString,

    removeRows(key) {
      EventBus.$emit('row-selection:delete', key);
    },
  },

  mounted() {
    EventBus.$on('row-selection:update', (payload) => {
      this.rowSelection = payload;
    });
  },
  destroyed() {
    EventBus.$off('row-selection:update');
  },
};
</script>

<style lang="stylus" scoped>
@import '~variables';
</style>
